import { render, staticRenderFns } from "./ReviewCriterion.vue?vue&type=template&id=2924d140&scoped=true"
import script from "./ReviewCriterion.vue?vue&type=script&lang=js"
export * from "./ReviewCriterion.vue?vue&type=script&lang=js"
import style0 from "./ReviewCriterion.vue?vue&type=style&index=0&id=2924d140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2924d140",
  null
  
)

export default component.exports